import React from 'react'
import Products from '../../../components/Products'


const ProductsPage = () => {
    return (
        <div className="w-full">
            <Products />
        </div>
    )
}

export default ProductsPage
